import { postHostedOnboardingValidateOptions } from '@onefootprint/fetch-hosted';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { checkDeviceInfo } from '@/idv2/utils/get-device';
import { redirectAfterIdentify } from '@/idv2/utils/loader-navigation';
import { getLogger } from '@/idv2/utils/logger';

const { logInfo, logWarn } = getLogger({ name: 'idv2', location: 'identify-validate' });

const validateSearchSchema = z.object({
  authToken: z.string(),
  isPasskeyAlreadyRegistered: z.boolean().optional().default(false),
});

export const Route = createFileRoute('/identify/validate')({
  validateSearch: validateSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const { authToken, isPasskeyAlreadyRegistered } = search;

    let validationToken: string;
    try {
      const result = await context.queryClient.fetchQuery(
        postHostedOnboardingValidateOptions({
          headers: { 'X-Fp-Authorization': authToken },
        }),
      );
      validationToken = result.validationToken;
      logInfo('Validation token generated');
    } catch (error) {
      logWarn('Onboarding validation error', error);
      throw await redirectAfterIdentify(context, { validationToken: authToken, authToken });
    }

    const device = await checkDeviceInfo();
    const shouldSkipPasskey = !device.hasSupportForWebauthn || isPasskeyAlreadyRegistered;

    if (shouldSkipPasskey) {
      throw await redirectAfterIdentify(context, { validationToken, authToken });
    }

    // Offer optional passkey registration
    throw redirect({
      to: '/identify/passkey-offer',
      search: { authToken, validationToken },
    });
  },
});
